import { atom } from "recoil";
import { persistAtom } from "./localStorageBase64";

export type MemberType = {
  p_id: number;
  name: string;
  manager: boolean;
};

export type WHType = {
  width: number;
  height: number;
};

export const loginState = atom<MemberType | null>({
  key: "loginState",
  default: null,
  effects_UNSTABLE: [persistAtom],
});

export const mobileState = atom<boolean>({
  key: "mobileState",
  default: false,
});

export const WHState = atom<WHType>({
  key: "WHState",
  default: {
    width: window.innerWidth,
    height: window.innerHeight,
  },
});
